import SigliveServiceV2 from 'Service/sigliveServiceV2';

const postImportSchedule = async ({ payload }) => {
  const response = await SigliveServiceV2({
    method: 'POST',
    url: `/schedule/import`,
    data: payload,
  });

  return response;
};

export default postImportSchedule;
